// reps options
export const CUSTOM_REP = 'Custom Rep';
export const METHOD = 'Method';
